export default __webpack_public_path__ + "static/media/x33mall-banner.ce537eab.jpg";